import type { Term } from "@models/ISchema";
import type { AnnualSchedulePeriod } from "../types";

/**
 * Maps an academic term to the period used to filter the annual weeks.
 *
 * @param term - Term picked in the period control; absent for the all-weeks option.
 * @returns The term's period, or null to include the entire catalog.
 */
export const getAnnualPeriod = (term?: Term | null): AnnualSchedulePeriod =>
  term
    ? {
        id: term.id,
        label: [term.code, term.name].filter(Boolean).join(" - "),
        start: term.start_date ?? "",
        end: term.end_date ?? "",
      }
    : null;

/**
 * Resolves the period the annual view opens with before the user picks one.
 *
 * @param term - The package's academic term, when it has one.
 * @returns The package term's period, or null to include the entire catalog.
 *
 * @remarks A term without dates overlaps no week, so it falls back to the entire
 * catalog instead of opening the view on an empty period.
 */
export const getDefaultAnnualPeriod = (term?: Term | null): AnnualSchedulePeriod => {
  const period = getAnnualPeriod(term);

  return period?.id && period.start && period.end ? period : null;
};
